import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Spinner from './Spinner'
import { RootReducer } from '../redux/rootReducer'
import { FETCH_TUTOR } from '../redux/tutorReducer'
import SignInScreen from './SignInScreen'

interface Props {
  children: JSX.Element
}

const AuthWrapper = ({ children }: Props) => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(FETCH_TUTOR())
  }, [dispatch])

  const authState = useSelector((state: RootReducer) => state.authReducer.authState)

  if (authState === 'authorized') {
    return <div>{children}</div>
  }
  if (authState === 'notAuthorized') {
    return <SignInScreen />
  }
  return <Spinner />
}

export default AuthWrapper
